/**
 * Thiết lập hiển thị
 * NVTUAN1 20.11.2023
 */
export default {
  ViewSmall: 1,
  ViewBig: 2,
};